import { CartItem } from '@/services/cart/model/cart';

export default class CartItemGroup {
  public readonly groupId: string;
  public readonly items: CartItem[];
  public readonly groupname: string;


  constructor(groupname: string, items: CartItem[]) {
    this.groupId = groupname;
    this.items = items;

    this.groupname = '';
    if (items.length > 0) {
      this.groupname = items[0].product.resolvedCategory.name;
    }
  }
}
